import React, { useEffect } from 'react'
import { CircularProgress } from '@mui/material'
import { useInView } from 'react-intersection-observer'

export interface LoadingSpinnerRowProps {
  onVisible?: () => void
}

export const LoadingSpinnerRow = ({
  onVisible,
  ...otherProps
}: LoadingSpinnerRowProps) => {
  const [inViewRef, inView] = useInView({ triggerOnce: true })
  useEffect(() => {
    if (inView) {
      onVisible?.()
    }
  }, [inView, onVisible])

  return (
    <>
      <tr style={{ textAlign: 'center' }}>
        <td style={{ columnSpan: 'all' }}>
          <CircularProgress
            ref={inViewRef}
            size={24}
            thickness={4}
            style={{ padding: '8px' }}
            {...otherProps}
          />
        </td>
      </tr>
    </>
  )
}
